import { render } from "./SectionScheduleComponent.vue?vue&type=template&id=38480ef2"
import script from "./SectionScheduleComponent.vue?vue&type=script&lang=js"
export * from "./SectionScheduleComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__